import { render } from "./KnowledgePanel.vue?vue&type=template&id=0e258180&scoped=true"
import script from "./KnowledgePanel.vue?vue&type=script&lang=js"
export * from "./KnowledgePanel.vue?vue&type=script&lang=js"

import "./KnowledgePanel.vue?vue&type=style&index=0&id=0e258180&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e258180"]])

export default __exports__